module.exports = __webpack_public_path__ + "static/img/ma.60fbc221.svg";